<template>
  <div v-if="searchResult.shipmentType !== 'INTERN' ">
    <v-stepper alt-labels elevation=0>
      <v-stepper-header>
        <v-stepper-step step="" :complete="latestStatus > 0" color="#F57F17">
          <small> {{ getStatusDate(searchResult.trackingStates.filter(s => s.statusNummer === 1)) }} </small>
          <p class="steppertext">Picked up goods</p>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="" :complete="latestStatus > 1" color="#F57F17">
          <small> {{ getStatusDate(searchResult.trackingStates.filter(s => s.statusNummer === 2)) }} </small>
          <p class="steppertext">Goods arrived in Altishofen</p>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="" :complete="latestStatus > 2" color="#F57F17">
          <small> {{ getStatusDate(searchResult.trackingStates.filter(s => s.statusNummer === 3)) }} </small>
          <p class="steppertext finalStatus"> {{ finalStatusText }} <br>
            <small v-if="getStatusDate(searchResult.trackingStates.filter(s => s.statusNummer === 3)) !== ''">
              <a class="url" :href="`${trackingLink}`" target="_blank">Track your package on their page</a>
            </small>
          </p>
        </v-stepper-step>

      </v-stepper-header>
    </v-stepper>
  </div>

  <div v-else-if="searchResult.shipmentType === 'INTERN'">
    <v-stepper
        alt-labels
        v-model="latestStatus"
        elevation=0
    >
      <v-stepper-header>
        <v-stepper-step step="" :complete="latestStatus > 0" color="#F57F17">
          <small> {{ getStatusDate(searchResult.trackingStates.filter(s => s.statusNummer === 1)) }} </small>
          <p class="text-sm-left text-md-center text-lg-center text-xl-center ">Picked up goods </p>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="" :complete="latestStatus > 1" color="#F57F17">
          <small> {{ getStatusDate(searchResult.trackingStates.filter(s => s.statusNummer === 2)) }} </small>
          <p class="text-sm-left text-md-center text-lg-center text-xl-center ">Goods arrived in Altishofen </p>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="" :complete="latestStatus > 2" color="#F57F17">
          <small> {{ getStatusDate(searchResult.trackingStates.filter(s => s.statusNummer === 3)) }} </small>
          <p class="text-sm-left text-md-center text-lg-center text-xl-center "> Out for delivery </p>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="" :complete="latestStatus > 3" color="#F57F17">
          <small> {{ getStatusDate(searchResult.trackingStates.filter(s => s.statusNummer === 4)) }} </small>
          <p class="text-sm-left text-md-center text-lg-center text-xl-center finalStatus">{{ finalStatusText }}</p>
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
  </div>

</template>
<script>
export default {
  name: "horizontalStepper",

  props: {
    searchResult: {
      caseId: null,
      shipmentNumberPost: null,
      shipmentNumberDhl: null,
      shipmentType: null,
      hasDocument: null,
      trackingStates: []
    },
    trackingLink: null,
    latestStatus: null,
  },
  data: () => ({
    finalStatusText: "Goods have been delivered"
  }),
  mounted(){
    // as soon as we know that package goes to post or dhl - text will change to "...forwarded to"
    if( this.searchResult.shipmentType === "DHL" || this.searchResult.shipmentType === "POST") {
      this.finalStatusText = "Goods have been forwarded to " + String(this.searchResult.shipmentType)
    }else{
      this.finalStatusText = "Goods have been delivered"
    }
  },

  methods: {
    /**
     * Returns the date of the status if the status is available. Otherwise returns empty string
     * Needed to return empty string of unavailable statis in steppers
     * @param status
     * @returns {string|string|*}
     */
    getStatusDate: function (status) {
      //if status 1,2,3,4 or 5 is available, resp. array not empty return the date (yyyy-mm-dd)
      if (typeof status != "undefined" && status != null && status.length != null && status.length > 0) {
        return String(status[0].date).substring(0,16)

      //return empty string
      } else {
        return ''
      }
    }


  }

}


</script>

<style scoped>

</style>